<div class="modal activated-mdn">
    <div class="model-container">
        <div class="modal-header">
                <h3 class="modal-heading" *ngIf="!successResult && !failureResult" translate>{{!waitingConfirmCode ?
                    'activated-mdn.add-activated-number' : 'activated-mdn.verify-your-number' | translate}}</h3>
                <img class="modal-close" (click)="closeDialog()" src="/assets/icon/primary-close.svg" alt="close-icon"
                    width="28" height="28">
        </div>
        <div class="modal-body">
            <div class="contents" *ngIf="!successResult && !failureResult">
                <ng-container *ngIf="!waitingConfirmCode">
                    <form [formGroup]="activatingPhoneForm" class="phone-number-section">
                        <p class="smaller" translate>activated-mdn.enter-your-active-mdn</p>
                        <div class="specific-width">
                            <label class="outlined-label-input">
                                <input placeholder=" " formControlName="phoneNumber" id="phoneNumber"
                                    data-cy="phoneNumber" type="tel" required minlength="10" maxlength="10"
                                    restrictNumbers />
                                <span translate>activated-mdn.g2g-phone-number</span>
                            </label>
                            <label class="validation-message" translate
                                *ngIf="activatingPhoneForm.controls['phoneNumber'].hasError('required') && activatingPhoneForm.controls['phoneNumber'].touched">
                                activated-mdn.number-required
                            </label>
                            <label class="validation-message" translate
                                *ngIf="!!activatingPhoneForm.controls['phoneNumber'].value && activatingPhoneForm.controls['phoneNumber'].hasError('minlength')">
                                activated-mdn.number-invalid
                            </label>
                        </div>
                    </form>
                    <div class="modal-actions">
                        <button class="button primary" (click)="sendCode()" type="submit" id="Confirm"
                            translate>activated-mdn.confirm
                        </button>
                    </div>
                </ng-container>
                <ng-container *ngIf="!!waitingConfirmCode">
                    <p class="confirm-code-title" translate>activated-mdn.sent-verification-code</p>
                    <p class="confirm-code-phone"><b>{{phoneNumber | mdn}} </b></p>
                    <form [formGroup]="verificationForm" class="verification-section">
                        <div class="specific-width">
                            <label class="outlined-label-input">
                                <input placeholder=" " formControlName="verificationCode" id="verificationCode"
                                    type="tel" required minlength="4" restrictNumbers />
                                <span translate>activated-mdn.verification-code</span>
                            </label>
                            <label class="validation-message" translate
                                *ngIf="verificationForm.controls['verificationCode'].hasError('required') && verificationForm.controls['verificationCode'].touched">
                                activated-mdn.code-required
                            </label>
                            <label class="validation-message" translate
                                *ngIf="!!verificationForm.controls['verificationCode'].value && verificationForm.controls['verificationCode'].hasError('minlength')">
                                activated-mdn.code-invalid
                            </label>
                        </div>
                    </form>
                    <div class="modal-actions">
                        <button class="button primary" (click)="verifyLoginCode()"
                            translate>activated-mdn.verify-login-code
                        </button>
                    </div>
                </ng-container>
            </div>
            <div class="contents" *ngIf="!!failureResult">
                <img src="/assets/img/error.svg" width="100" height="100" alt="result img">
                <h4 class="title">{{(customFailureResult? ('activated-mdn.invalid-verification-code' | translate):
                    'activated-mdn.sth-went-wrong' | translate)}}</h4>
                <div class="inner-content">
                    <p class="end-note">
                        {{customFailureResult?('activated-mdn.recheck-entries' | translate):('activated-mdn.we-couldnot-process-request' | translate)}}
                </div>
                <div class="modal-actions">
                    <button class="button primary" (click)="recheckIntries()" *ngIf="!!customFailureResult"
                        translate>activated-mdn.got-it</button>
                    <button class="button primary" (click)="cancel()" *ngIf="!customFailureResult"
                        translate>activated-mdn.got-it</button>
                </div>

            </div>
        </div>
    </div>
</div>